module.exports = __webpack_public_path__ + "img/newlogo.1d348399.svg";